module.exports = __webpack_public_path__ + "img/clipboard-check.f76456ed.svg";